export default "__VITE_ASSET__DFP$WESX__"